// extracted by mini-css-extract-plugin
module.exports = {"serverStatus":"ServerStatus_serverStatus__2ctVX","tooltip":"ServerStatus_tooltip__bgJue","tooltipContentBoxContent":"ServerStatus_tooltipContentBoxContent__18qYM"};